import { useSelector } from 'react-redux';

import { useDispatcher } from '../../shared/hooks/index.js';
import { PanelHeader } from '../../shared/interface/index.js';
import { RootState, routerActions, Selectors, useCurrentFolderQuery } from '../../store/index.js';

interface Props {
    actionMenu?: any;
    title?: string;
    subtitle?: string;
    onBack?: AnyFunction;
    playbookType: string;
}

const PlaybookHeader: FC<Props> = ({ actionMenu, title, subtitle, onBack, playbookType }) => {
    const openPlayFolder = useDispatcher(routerActions.OpenPlayFolder);
    const parentFolderId = useSelector((state: RootState) => Selectors.parentFolderId(state, playbookType));
    const { data: currentFolder } = useCurrentFolderQuery({ playbookType });

    const openParentFolder = () => {
        openPlayFolder(parentFolderId);
    };

    return (
        <PanelHeader
            actionMenu={actionMenu}
            onBack={currentFolder ? () => openParentFolder() : onBack}
            title={currentFolder?.name ?? title}
            subtitle={currentFolder ? 'Folder' : subtitle}
        />
    );
};

export default PlaybookHeader;
